import { toInteger } from 'lodash';
import { createCanvas } from '@/utils/file-kit';
import type { IChartLayer, ISize } from '@/version-types';
import { renderLayerContentToCanvas } from './render-to-canvas';

export const renderLayerToStage = async (
    layer: IChartLayer,
    resultSize: ISize,
): Promise<HTMLCanvasElement | undefined> => {
    const { width, height, left, top, rotate } = layer;
    const { width: stageWidth, height: stageHeight } = resultSize;
    const resultWidth = toInteger(width);
    const resultHeight = toInteger(height);
    const centerPoint = {
        x: resultWidth / 2 + left,
        y: resultHeight / 2 + top,
    };
    const drawOffsetPoint = {
        x: -resultWidth / 2,
        y: -resultHeight / 2,
    };
    const layerImage = await renderLayerContentToCanvas(layer, false);
    if (!layerImage) return;

    const { canvas: destCanvas, ctx: destCtx } = createCanvas(stageWidth, stageHeight);
    destCtx.translate(centerPoint.x, centerPoint.y);
    destCtx.rotate((Math.PI / 180) * rotate);
    destCtx.drawImage(
        layerImage,
        0,
        0,
        resultWidth,
        resultHeight,
        drawOffsetPoint.x,
        drawOffsetPoint.y,
        resultWidth,
        resultHeight,
    );

    return destCanvas;
};
